import { ISortSelectOption } from 'src/components/filter/types/filter.types'

export const accountUsersSortOptions: ISortSelectOption[] = [
  { label: 'sort-email-desc.v', value: 'user.email-desc' },
  { label: 'sort-email-asc.v', value: 'user.email-asc' },
  { label: 'sort-created-desc.v', value: 'account_users.created_at-desc' },
  { label: 'sort-created-asc.v', value: 'account_users.created_at-asc' },
  { label: 'sort-updated-desc.v', value: 'account_users.updated_at-desc' },
  { label: 'sort-updated-asc.v', value: 'account_users.updated_at-asc' },
]

export * from './can-resend-invite.util'
